import { render, staticRenderFns } from "./slides.vue?vue&type=template&id=7d6df3d1&scoped=true&"
import script from "./slides.vue?vue&type=script&lang=js&"
export * from "./slides.vue?vue&type=script&lang=js&"
import style0 from "./slides.vue?vue&type=style&index=0&id=7d6df3d1&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6df3d1",
  null
  
)

export default component.exports